import styled from "styled-components";

import { mixins, colorsPalettes } from "@similarweb/styles";

import { Flex } from "pro-features/components/core cells/src/CoreWebsiteCell/StyledComponents";

export const SearchContainer = styled.div`
    display: flex;
    align-items: center;
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    padding: 8px 16px 8px 0;
    height: 39px;
    .SearchInput-container {
        flex-grow: 1;
    }
    .SearchInput-container .SearchInput {
        height: 34px;
        background-color: ${colorsPalettes.carbon[0]};
        border: none;
        width: 100%;
        box-sizing: border-box;
        padding: 9px 2px 5px 50px;
        box-shadow: none;
        margin-bottom: 0px;
        &:focus {
            box-shadow: none !important;
            border: none;
        }
    }
`;
SearchContainer.displayName = "SearchContainer";

export const DownloadExcelContainer = styled.span`
    margin: 0 8px 0 16px;
`;

export const TrialLink = styled.div`
    ${mixins.setFont({ $size: 14 })};
    text-transform: uppercase;
    color: ${colorsPalettes.blue[400]};
    font-weight: 500;
    &:hover {
        cursor: pointer;
    }
`;
TrialLink.displayName = "TrialLink";

const RowSelector = styled.div`
    margin-left: 48px;
    flex-grow: 1;
    align-self: stretch;
    opacity: 0.1;
    cursor: pointer;
`;

RowSelector.displayName = "RowSelector";

export const DomainNameAndIconWrapper = styled(Flex)`
    width: 100%;
`;

export const HeaderCellBoldWithInfoWrapper = styled(Flex)`
    width: 100%;
    align-items: center;
    justify-content: left;
    .SWReactIcons {
        margin-left: 4px;
    }
`;

export const StyledHeaderCellBoldWrapper = styled.div`
    width: fit-content;
`;

export const StyledIconInfoWrapper = styled.div`
    .SWReactIcons {
        width: 12px;
        height: 12px;
    }
`;
